import {DEFAULT_ENTITY_NAMED_LIST, DEFAULT_PAGE_SIZE} from 'app/app.constants';
import {EntityView} from 'app/blocks/util/entity-view';

import {ListViewParams} from 'app/blocks/util/list-view-params';
import {PartialEntityStateModel} from 'app/blocks/store/state-model/partial-entity-state-model';
// import { FilterParams } from 'app/blocks/util/filter-params';

export interface EntityStateModel<T> extends PartialEntityStateModel<T> {
    listView: {
        initialized: boolean;
        entityList: T[];
        totalItems: number;
        viewParams: ListViewParams;
        statusLoading: boolean;
        selectedIds: number[];
        // filters: FilterParams[]
    };
    entityView: {
        currentEntity: T;
        statusSaving: boolean;
        statusDeleting: boolean;
        selectedTabIndex: number;
    };
    currentView: EntityView;
}

function listViewParams(desc = false, field = 'id'): ListViewParams {
    return {
        pageIndex: 0,
        pageSize: DEFAULT_PAGE_SIZE,
        sortColumn: field,
        sortDirection: desc ? 'desc' : 'asc',
        filter: '',
        filterParams: []
    } as ListViewParams;
}

function listViewParamsWithDefaultFilters(desc = false, field = 'id', defaultFilters = []): ListViewParams {
    return {
        pageIndex: 0,
        pageSize: DEFAULT_PAGE_SIZE,
        sortColumn: field,
        sortDirection: desc ? 'desc' : 'asc',
        filter: '',
        filterParams: defaultFilters
    } as ListViewParams;
}

export const defaultEntityState = (entityCreator: (entity?) => any, reverse = false, field = 'id') => {
    return {
        listView: {
            initialized: false,
            entityList: [],
            totalItems: 0,
            viewParams: listViewParams(reverse, field),
            statusLoading: false,
            selectedIds: []
            // filters: []
        },
        entityView: {
            currentEntity: entityCreator(),
            statusSaving: false,
            statusDeleting: false,
            selectedTabIndex: 0
        },
        partialEntity: {
            [DEFAULT_ENTITY_NAMED_LIST]: {
                list: [],
                loaded: false
            }
        },
        currentView: EntityView.LIST
    };
};

export const defaultEntityStateWithDefaultFilters = (entityCreator: (entity?) => any, reverse = false, field = 'id', defaultFilterParam = []) => {
    return {
        listView: {
            initialized: false,
            entityList: [],
            totalItems: 0,
            viewParams: listViewParamsWithDefaultFilters(reverse, field, defaultFilterParam),
            statusLoading: false,
            selectedIds: []
        },
        entityView: {
            currentEntity: entityCreator(),
            statusSaving: false,
            statusDeleting: false,
            selectedTabIndex: 0
        },
        partialEntity: {
            [DEFAULT_ENTITY_NAMED_LIST]: {
                list: [],
                loaded: false
            }
        },
        currentView: EntityView.LIST
    };
};
